import { c as _c } from "react/compiler-runtime";
import { AnalyticsTable } from "@components/analytics/in-house/analytics-table";
import { ANALYTICS_REQUIRED_TABLE_COLUMNS } from "@components/analytics/in-house/constants/analytics-constants";
import { useAnalyticsProjectsBreakdownData } from "@components/analytics/in-house/hooks/use-analytics-projects-breakdown-data";
import { EntitiesToolbar } from "@components/common/toolbar/entities-toolbar";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { searchSelector } from "@store/ui/ui-selector";
import { CommonStyles } from "@styles/common-styles";
/** Container for analytics breakdown data fetching, search filtering and responsive rendering. */
export function AnalyticsProjectsBreakdown(t0) {
  const $ = _c(18);
  const {
    selectedRange,
    selectedMetricKey
  } = t0;
  const {
    debouncedSearchText,
    isDebouncingSearch
  } = useAppSelector(searchSelector);
  let t1;
  if ($[0] !== debouncedSearchText || $[1] !== selectedMetricKey || $[2] !== selectedRange) {
    t1 = {
      selectedRange,
      selectedMetricKey,
      debouncedSearchText
    };
    $[0] = debouncedSearchText;
    $[1] = selectedMetricKey;
    $[2] = selectedRange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    projects,
    totalCount,
    isFetchingProjects
  } = useAnalyticsProjectsBreakdownData(t1);
  const isTableLoading = isFetchingProjects || isDebouncingSearch;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      border: CommonStyles.Borders.divider,
      borderRadius: "0.5rem",
      overflow: "hidden",
      p: 4
    };
    t3 = <Text variant="heading20">Breakdown by projects</Text>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isTableLoading || $[7] !== totalCount) {
    t4 = <EntitiesToolbar toolbarEntityName="Project" numberOfRows={totalCount} shouldShowRowsLabel={false} isLoading={isTableLoading} />;
    $[6] = isTableLoading;
    $[7] = totalCount;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [...ANALYTICS_REQUIRED_TABLE_COLUMNS];
    t6 = {
      nonConfigurableColumns: ["options"],
      defaultVisibleColumns: ["projectName", "totalViews", "projectManager", "group", "createdDate"]
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isTableLoading || $[12] !== projects || $[13] !== selectedMetricKey) {
    t7 = <ColumnPreferencesProvider tableKey="analytics-projects-table" columns={t5} options={t6}><AnalyticsTable projects={projects} isLoading={isTableLoading} selectedMetricKey={selectedMetricKey} /></ColumnPreferencesProvider>;
    $[11] = isTableLoading;
    $[12] = projects;
    $[13] = selectedMetricKey;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t7) {
    t8 = <Box data-testid="analytics-table" sx={t2}>{t3}{t4}{t7}</Box>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}